import React from 'react';
import { connect } from 'react-redux';

import { closeDeeplinkBanner } from 'depop/state/overlays';
import { isBannerPlatform } from 'depop/utils/deeplinks';
import { emmitButtonClick } from 'depop/apps/root/components/HomeAB';
import { withRouter } from 'depop/contextWrappers';

import AppBanner from './AppBanner';

class DeeplinkBanner extends React.Component {
  props: {
    overlays: Object,
    userAgent: Object,
    onClose: () => void,
  };

  constructor(props) {
    super(props);
    this.state = { mounted: false };
  }

  componentDidMount() {
    this.setState({mounted: true});
  }

  winExperiment() {
    return emmitButtonClick('open in app');
  }

  render() {
    const { userAgent, overlays, onClose, router } = this.props;
    const { mounted } = this.state;
    const { isJourneyOn, open, deeplink, landingAB } = overlays;
    const isLanding = router.isActive('/', true);
    // const isVariantB = (landingAB === 'B');
    // const isLandingBVariant = isLanding && isVariantB;
    const bannerShouldNotShow = isJourneyOn || !mounted || !isBannerPlatform(userAgent.platform); // || isLandingBVariant || isShopGuest;
    const channel = isLanding ? `landingpage_mobile_${userAgent.isAndroid ? 'google' : 'apple'}_a` : undefined;

    if (bannerShouldNotShow) {
      return null;
    }

    return <AppBanner close={onClose} open={open} clickAction={this.winExperiment} {...deeplink} channel={channel} />;
  }
}

const mapStateToProps = ({userAgent, overlays}) => ({
  userAgent,
  overlays,
});

const mapDispatchToProps = (dispatch) => {
  return {
    onClose: () => dispatch(closeDeeplinkBanner()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DeeplinkBanner));



// WEBPACK FOOTER //
// ../src/client/components/banners/DeeplinkBanner.js